import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, defineComponent, nextTick, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import InlineLoader from "@Shared/components/general/inline-loader";
import vSelect from "vue-select";
import { debounce, uniqBy, isEmpty } from "lodash";
import { V_SELECT_SCENARIO } from "@Shared/js/constants";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  components: {
    vSelect,
    InlineLoader,
    ProfileAvatar
  },
  props: {
    value: {
      type: null,
      default: null
    },
    options: {
      type: [Array, Object],
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "label"
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    infiniteScrollMode: {
      type: Boolean,
      default: false
    },
    loadingOptions: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingMoreStop: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    removeDuplicatesBy: {
      type: String,
      default: ""
    },
    searchMinCharacters: {
      type: Number,
      default: null
    },
    autoscroll: {
      type: Boolean,
      default: true
    },
    noOptionsText: {
      type: String,
      default: ""
    },
    scenario: {
      type: String,
      default: V_SELECT_SCENARIO.simple
    },
    multiple: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [Object, Array, String, Number],
      required: false,
      default: null
    },
    extraSelectData: {
      type: Array,
      default: () => []
    },
    action: {
      type: String,
      default: ""
    },
    hasCheckboxes: {
      type: Boolean,
      default: false
    },
    deselectFromDropdown: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: "en"
    },
    hasActiveFilters: {
      type: Boolean,
      default: false
    },
    deleteOptions: {
      type: Boolean,
      default: false
    },
    referrersCheckboxes: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t,
      tc
    } = useI18n();
    const {
      infiniteScrollMode,
      loadingMoreStop,
      loadingOptions,
      options,
      removeDuplicatesBy,
      searchMinCharacters,
      defaultValue,
      multiple,
      extraSelectData,
      action,
      hasCheckboxes,
      scenario,
      language,
      clearable,
      hasActiveFilters,
      deleteOptions
    } = toRefs(props);
    const select = ref(null);
    const loader = ref();
    const model = ref(defaultValue.value);
    let refOptions = ref(options.value);
    let observer = null;
    let checkboxes = ref([]);
    let currentOptionsSelected = ref([]);
    let allOption = ref({
      id: "all",
      label: tc("global.words.all", 1)
    });
    watch(defaultValue, () => {
      var _context5;
      /*
       * Switch used specifically in the multiple case (aka reports)
       */
      if (multiple.value && !hasCheckboxes.value) {
        if (scenario.value === "agents") {
          model.value = defaultValue.value;
        }
        switch (action.value) {
          case "clear":
            model.value = extraSelectData.value;
            break;
          case "reset":
            if (!defaultValue.value.some(dv => dv == null)) {
              model.value = defaultValue.value;
            }
            break;
          default:
        }
      }
      if (multiple.value && hasCheckboxes.value) {
        if (scenario.value === "applicationStatus" && (defaultValue == null ? void 0 : defaultValue.value.length) == 2) {
          var _context;
          model.value = _filterInstanceProperty(_context = options.value).call(_context, val => {
            var _context2;
            return _includesInstanceProperty(_context2 = defaultValue.value).call(_context2, val.id);
          });
          currentOptionsSelected.value = model.value;
          checkboxes.value = model.value;
          return;
        }
        if (scenario.value === "riskLevel" && (Array.isArray(defaultValue.value) || defaultValue.value === "")) {
          if (defaultValue.value === "" || Array.isArray(defaultValue.value) && defaultValue.value.length === 0) {
            model.value = [];
            checkboxes.value = [];
            currentOptionsSelected.value = [];
          } else {
            var _context3;
            model.value = _filterInstanceProperty(_context3 = options.value).call(_context3, val => {
              var _context4;
              return _includesInstanceProperty(_context4 = defaultValue.value).call(_context4, val.id);
            });
            currentOptionsSelected.value = model.value;
            checkboxes.value = model.value;
          }
        }
        switch (action.value) {
          case "clear":
          case "reset":
            model.value = _filterInstanceProperty(_context5 = options.value).call(_context5, v => {
              var _context6;
              return _includesInstanceProperty(_context6 = defaultValue.value).call(_context6, v.id);
            });
            currentOptionsSelected.value = model.value;
            if (defaultValue.value && defaultValue.value.length == 0) checkboxes.value = [];
            break;
          default:
        }
      } else if (scenario.value == "simple" || scenario.value == "lenderProduct" || scenario.value == "lenderName" || scenario.value == "board" || scenario.value == "agents" || scenario.value === "reports") {
        if (defaultValue.value === null || defaultValue.value === undefined || defaultValue.value === "") {
          model.value = defaultValue.value;
        } else {
          if (defaultValue.value === "brokerage") {
            var _context7, _context9;
            model.value = _filterInstanceProperty(_context7 = options.value).call(_context7, v => {
              var _context8;
              return _includesInstanceProperty(_context8 = ["group", "brokerage", "paid", "closed"]).call(_context8, v.id);
            }).length > 0 ? _filterInstanceProperty(_context9 = options.value).call(_context9, v => {
              var _context0;
              return _includesInstanceProperty(_context0 = ["group", "brokerage", "paid", "closed"]).call(_context0, v.id);
            })[0].text : "";
          } else if (scenario.value == "lenderProduct") {
            var _context1;
            const filteredOptions = _filterInstanceProperty(_context1 = options.value).call(_context1, v => v.id === defaultValue.value || v.value === defaultValue.value);
            model.value = filteredOptions.length > 0 ? typeof filteredOptions[0].label === "string" ? filteredOptions[0].label : filteredOptions[0].label[language.value] : "";
          } else if (scenario.value == "board") {
            var _context10;
            const filteredOptions = _filterInstanceProperty(_context10 = options.value).call(_context10, v => v === defaultValue.value);
            const defaultBoard = filteredOptions[0].owner && filteredOptions[0].default ? filteredOptions[0].label + ` (${t("global.words.default").toLowerCase()})` : filteredOptions[0].label;
            model.value = filteredOptions.length > 0 ? defaultBoard : "";
          } else if (scenario.value == "agents" && hasActiveFilters) {
            // case when you want to filter agents from applications page
            model.value = defaultValue.value;
          } else {
            var _context11;
            if (scenario.value === "lenderName") {
              if (options.value.length === 0) return;
            }
            const filteredOptions = _filterInstanceProperty(_context11 = options.value).call(_context11, v => v.id === defaultValue.value || v.value === defaultValue.value);
            model.value = filteredOptions.length > 0 ? filteredOptions[0].text || filteredOptions[0].label : "";
          }
        }
      } else {
        if (defaultValue.value && defaultValue.value.length == 0) {
          model.value = "";
        }
      }
    }, {
      immediate: true
    });
    watch(options, () => {
      refOptions.value = options.value;
      if (scenario.value === "simple") {
        var _context12;
        const filteredOptions = _filterInstanceProperty(_context12 = options.value).call(_context12, v => v.id === defaultValue.value || v.value === defaultValue.value);
        model.value = filteredOptions.length > 0 ? filteredOptions[0].text || filteredOptions[0].label : "";
      }
    }, {
      immediate: true
    });
    const dropdownShouldOpen = VueSelect => {
      if (!searchMinCharacters.value || !VueSelect.search) return VueSelect.open;
      return searchMinCharacters.value < VueSelect.search.length && VueSelect.open;
    };
    const Deselect = {
      render: createElement => createElement("span", {
        class: {
          "fa fa-times": true,
          "text-gray": !hasCheckboxes.value,
          "d-none": model.value ? model.value.length === 0 && scenario.value === "referrers" : true
        },
        on: {
          click: () => {
            if (clearable.value && scenario.value !== "referrers") {
              emit("clear");
            }
          }
        }
      })
    };
    const infiniteScroll = async ([{
      isIntersecting,
      target
    }]) => {
      if (loadingOptions.value) return;
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        emit("load-more");
        await nextTick();
        ul.scrollTop = scrollTop;
      }
    };
    const infiniteScrollFunctionality = computed(() => infiniteScrollMode.value && !loadingMoreStop.value);
    onMounted(async () => {
      if (infiniteScrollMode.value) observer = new IntersectionObserver(infiniteScroll);
      if (multiple.value && hasCheckboxes.value && scenario.value !== "documents") {
        var _context13;
        await nextTick();
        model.value = _filterInstanceProperty(_context13 = options.value).call(_context13, v => {
          var _context14;
          return defaultValue == null ? void 0 : _includesInstanceProperty(_context14 = defaultValue.value).call(_context14, v.id);
        });
        currentOptionsSelected.value = model.value;
        checkboxes.value = [{
          id: defaultValue.value
        }];
      }
    });
    const handleSelect = selectedOption => {
      var _context22;
      /*
       * In the case of multiple selection when one starts selecting a certain value the default All must be removed
       */
      if (multiple.value && !hasCheckboxes.value) {
        var _context15;
        /*
         * If All option is selected all other existing options need to be removed and only All option to remain
         */
        if (_includesInstanceProperty(_context15 = model.value).call(_context15, selectedOption)) return;
        if (_sliceInstanceProperty(selectedOption).call(selectedOption, -1)[0].id == "all") {
          model.value = selectedOption.pop();
          emit("option:selected", [model.value], "select");
        } else {
          var _context16;
          model.value = _filterInstanceProperty(_context16 = model.value).call(_context16, m => m.id !== "all");
          emit("option:selected", selectedOption, "select");
        }
        return;
      } else if (scenario.value === "documents") {
        let emitValue = selectedOption;
        if (hasCheckboxes.value) {
          if (model.value.length === options.value.length) {
            emitValue = allOption.value;
            checkboxes.value = [allOption.value, ...options.value];
          } else {
            var _context18;
            const difference = _filterInstanceProperty(selectedOption).call(selectedOption, selected => {
              var _context17;
              return !_findInstanceProperty(_context17 = checkboxes.value).call(_context17, check => selected.id === check.id);
            });
            checkboxes.value = selectedOption;
            emitValue = difference[0];
            model.value = _filterInstanceProperty(_context18 = model.value).call(_context18, m => m.id !== "all");
            currentOptionsSelected.value = model.value;
          }
        }
        emit("option:selected", emitValue);
        return;
      } else if (multiple.value && hasCheckboxes.value) {
        let newOption = selectedOption.length > 1 ? _filterInstanceProperty(selectedOption).call(selectedOption, x => {
          var _context19;
          return !_includesInstanceProperty(_context19 = currentOptionsSelected.value).call(_context19, x);
        })[0] : selectedOption[0];
        if (newOption.id === "all") {
          var _context20;
          model.value = _filterInstanceProperty(_context20 = model.value).call(_context20, v => v.id === "all");
          currentOptionsSelected.value = model.value;
        } else {
          var _context21;
          model.value = _filterInstanceProperty(_context21 = model.value).call(_context21, m => m.id !== "all");
          currentOptionsSelected.value = model.value;
        }
        checkboxes.value = model.value;
        emit("option:selected", newOption, "select");
        return;
      } else if (_includesInstanceProperty(_context22 = ["simple", "referrers", "lenderProduct", "board", "agents"]).call(_context22, scenario.value) || !multiple.value) {
        nextTick(() => {
          model.value = selectedOption.text || selectedOption.label || selectedOption.fullName || selectedOption.brokerageName;
        });
        emit("option:selected", selectedOption, "select");
        return;
      }
    };
    const handleDeselect = selectedOption => {
      if (scenario.value === "riskLevel" && selectedOption.id === "all") {
        model.value = [];
        checkboxes.value = [];
        currentOptionsSelected.value = [];
        emit("option:deselected", selectedOption, "unselect");
        return;
      }
      if (scenario.value === "documents") {
        if (hasCheckboxes.value) {
          var _context24;
          if (selectedOption.id === "all") {
            checkboxes.value = [];
            emit("option:unselected", selectedOption);
          }
          if (checkboxes.value.length === options.value.length + 1) {
            var _context23;
            checkboxes.value = _filterInstanceProperty(_context23 = checkboxes.value).call(_context23, item => item.id != selectedOption.id && item.id != allOption.value.id);
            emit("option:unselected", selectedOption);
          }
          checkboxes.value = _filterInstanceProperty(_context24 = checkboxes.value).call(_context24, item => item.id != selectedOption.id);
          emit("option:unselected", selectedOption);
        }
      } else if (multiple.value && hasCheckboxes.value && !model.value.length) {
        var _context25;
        /*
         * If all options were unselected Use the ALL as default
         */
        model.value = scenario.value == "simple" || scenario.value == "applicationStatus" || scenario.value == "agents" || scenario.value == "referrers" ? [] : _filterInstanceProperty(_context25 = options.value).call(_context25, op => op.id === "all");
        const input = select.value.$el.querySelector("input");
        input.focus();
        currentOptionsSelected.value = model.value;
      } else if (multiple.value && hasCheckboxes.value) {
        var _context26;
        currentOptionsSelected.value = _filterInstanceProperty(_context26 = options.value).call(_context26, v => {
          var _context27;
          return _includesInstanceProperty(_context27 = defaultValue.value).call(_context27, v.id);
        });
      } else if (multiple.value && !model.value.length || scenario.value === "agents") {
        /*
         * If all options were unselected Use the default extraSelectData
         */
        if (deleteOptions.value) {
          model.value = [];
          const input = select.value.$el.querySelector("input");
          input.focus();
        }
      }
      checkboxes.value = model.value;
      emit("option:deselected", selectedOption, "unselect");
    };
    const handleSearch = debounce((search, loading) => {
      if (scenario.value === "simple") {
        var _context28;
        optionsToUse.value = _filterInstanceProperty(_context28 = options.value).call(_context28, op => {
          var _context29;
          const value = op.text ? op.text : op.label;
          return _indexOfInstanceProperty(_context29 = value.toLocaleLowerCase()).call(_context29, search.toLocaleLowerCase()) > -1;
        });
      } else if (scenario.value === "agents") {
        var _context30;
        optionsToUse.value = _filterInstanceProperty(_context30 = options.value).call(_context30, op => {
          var _context31;
          return _includesInstanceProperty(_context31 = op.fullName.toLowerCase()).call(_context31, search.toLocaleLowerCase());
        });
      } else {
        emit("search", search, loading);
      }
    }, 200);
    const handleOpen = async () => {
      if (infiniteScrollFunctionality.value) {
        await nextTick();
        observer.observe(loader.value);
      }
    };
    const handleClose = () => {
      emit("close");
      if (observer) observer.disconnect();
      dropdownShouldOpen.value = !searchMinCharacters.value;
    };
    const optionsWithNoDuplicates = computed(() => uniqBy(options.value, removeDuplicatesBy.value));
    const optionsToUse = computed({
      get() {
        return removeDuplicatesBy.value ? optionsWithNoDuplicates.value : refOptions.value;
      },
      set(newValue) {
        refOptions.value = newValue;
      }
    });
    const avatarInitials = option => {
      var _context32, _context33;
      return `${_trimInstanceProperty(_context32 = option.givenName).call(_context32).charAt(0)}${_trimInstanceProperty(_context33 = option.familyName).call(_context33).charAt(0)}`;
    };
    const isChecked = option => {
      var _context34;
      return !isEmpty(_findInstanceProperty(_context34 = checkboxes.value).call(_context34, item => item.id == option));
    };
    const lenderProductValue = option => {
      return typeof option.label === "string" ? option.label : option.label[language.value];
    };
    const selectAll = () => {
      if (model.value.length == options.value.length) {
        model.value = [];
        checkboxes.value = [];
        emit("option:unselected", allOption.value);
      } else {
        model.value = options.value;
        currentOptionsSelected.value = model.value;
        checkboxes.value = [allOption.value, ...options.value];
        emit("option:selected", allOption.value);
      }
    };
    return {
      allOption,
      checkboxes,
      currentOptionsSelected,
      select,
      dropdownShouldOpen,
      infiniteScrollFunctionality,
      handleSearch,
      handleSelect,
      handleDeselect,
      handleOpen,
      handleClose,
      isChecked,
      selectAll,
      loader,
      Deselect,
      optionsToUse,
      model,
      avatarInitials,
      lenderProductValue,
      refOptions
    };
  }
});